import { components, isEmpty } from '@/utils'

function renderLabel(h) {
  if (this.label) {
    return h(
      'label',
      {
        attrs: { for: this.$id },
        class: {
          [`${components.textarea}__label`]: true,
          [this.focusedClass]: this.isFocused
        },
        on: { mousedown: this._click }
      },
      [ this.label, this.required && '*' ].filter(Boolean).join(' ')
    )
  }
}

function renderPrefix(h) {
  if (!isEmpty(this.prefix)) {
    let opacity = 0
    if (!isEmpty(this.prefix) && (this.isFocused || !isEmpty(this.proxy))) {
      opacity = 1
    }

    return h(
      'div',
      {
        class: `${components.textarea}__prefix`,
        style: { opacity },
        domProps: { innerHTML: this.prefix }
      }
    )
  }
}
function renderInput(h) {
  return h(
    'g-input',
    {
      class: `${components.textarea}__input`,
      style: { resize: this.resize },
      props: this.$inputProps,
      on: this.$inputOn,
      ref: 'input'
    }
  )
}
function renderSuffix(h) {
  if (!isEmpty(this.suffix)) {
    return h(
      'div',
      {
        class: `${components.textarea}__suffix`,
        domProps: { innerHTML: this.suffix }
      }
    )
  }
}
function renderGroup(h) {
  return h(
    'div',
    {
      class: `${components.textarea}__group`,
      on: { click: this._click }
    },
    [
      renderPrefix.call(this, h),
      renderInput.call(this, h),
      renderSuffix.call(this, h)
    ]
  )
}

function renderLoading(h) {
  if (this.loading) {
    return h(
      'div',
      { class: `${components.textarea}__loading` }
    )
  }
}
function renderClearable(h) {
  if (this.isClearable) {
    return h(
      'div',
      {
        class: `${components.textarea}__after-holder`
      },
      [
        h(
          'g-icon',
          {
            class: { [this.focusedClass]: this.isFocused },
            props: { value: 'clear' },
            on: { click: this._clear }
          }
        )
      ]
    )
  }
}

function renderBeforeSlot(h) {
  if (this.hasBeforeSlot) {
    let before = this.$slots.before
    if (this.$scopedSlots.before) {
      before = this.$scopedSlots.before()
    }

    return h(
      'div',
      {
        class: `${components.textarea}__before-holder`
      },
      [ before ]
    )
  }
}
function renderBeforeIcon(h) {
  if (this.beforeIcon) {
    return h(
      'div',
      {
        class: `${components.textarea}__before-holder`
      },
      [
        h(
          'g-icon',
          {
            class: { [this.focusedClass]: this.isFocused },
            props: { value: this.beforeIcon },
            on: {
              click: () => {
                if (!this.isDisabled && typeof this.beforeIconCallback === 'function') {
                  this.beforeIconCallback()
                }
              }
            }
          }
        )
      ]
    )
  }
}
function renderBeforeContent(h) {
  return renderBeforeIcon.call(this, h)
}
function renderBefore(h) {
  if (this.hasBefore) {
    return h(
      'div',
      {
        class: {
          [`${components.textarea}__before`]: true,
          [`${components.textarea}__before--pointer`]: this.beforeIcon && typeof this.beforeIconCallback === 'function'
        }
      },
      [ renderBeforeSlot.call(this, h) || renderBeforeContent.call(this, h) ]
    )
  }
}

function renderAfterSlot(h) {
  if (this.hasAfterSlot) {
    let after = this.$slots.after
    if (this.$scopedSlots.after) {
      after = this.$scopedSlots.after()
    }

    return h(
      'div',
      {
        class: `${components.textarea}__after-holder`
      },
      [ after ]
    )
  }
}
function renderAfterIcon(h) {
  if (this.afterIcon) {
    return h(
      'div',
      {
        class: `${components.textarea}__after-holder`
      },
      [
        h(
          'g-icon',
          {
            class: { [this.focusedClass]: this.isFocused },
            props: { value: this.afterIcon },
            on: {
              click: () => {
                if (!this.isDisabled && typeof this.afterIconCallback === 'function') {
                  this.afterIconCallback()
                }
              }
            }
          }
        )
      ]
    )
  }
}
function renderAfterContent(h) {
  return renderAfterIcon.call(this, h)
}
function renderAfter(h) {
  if (this.hasAfter) {
    return h(
      'div',
      {
        class: {
          [`${components.textarea}__after`]: true,
          [`${components.textarea}__after--pointer`]: this.afterIcon && typeof this.afterIconCallback === 'function'
        }
      },
      [
        renderClearable.call(this, h),
        renderAfterSlot.call(this, h) || renderAfterContent.call(this, h)
      ]
    )
  }
}

function renderHolder(h) {
  return h(
    'div',
    {
      class: `${components.textarea}__holder`,
      style: { backgroundColor: this.backgroundColor }
    },
    [
      renderBefore.call(this, h),
      renderGroup.call(this, h),
      renderAfter.call(this, h),
      renderLoading.call(this, h)
    ]
  )
}

function renderDetails(h) {
  if (this.details) {
    return h(
      'div',
      {
        class: `${components.textarea}__details`
      },
      [
        h(
          'div',
          {
            class: `${components.textarea}__details--left`
          },
          this.$hint
        ),
        h(
          'div',
          {
            class: `${components.textarea}__details--right`
          },
          this.count
        )
      ]
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: this.$class
    },
    [
      renderLabel.call(this, h),
      renderHolder.call(this, h),
      renderDetails.call(this, h)
    ]
  )
}
